var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6061 6.25105C11.9409 6.58579 11.9409 7.1285 11.6061 7.46323L7.92632 11.143H19.5714C20.0448 11.143 20.4286 11.5268 20.4286 12.0002C20.4286 12.4736 20.0448 12.8573 19.5714 12.8573H7.92668L11.6061 16.5368C11.9409 16.8715 11.9409 17.4142 11.6061 17.749C11.2714 18.0837 10.7287 18.0837 10.3939 17.749L5.26246 12.6175C5.10066 12.4616 5 12.2426 5 12.0002C5 11.8993 5.01744 11.8024 5.04948 11.7125C5.09079 11.5962 5.15799 11.487 5.25108 11.3939L10.3939 6.25105C10.7287 5.91632 11.2714 5.91632 11.6061 6.25105Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft1);
export default __webpack_public_path__ + "static/media/arrow-left-1.314d29a5ea3e571a95a1ac5c6a513b74.svg";
export { ForwardRef as ReactComponent };